import { createAction } from 'redux-actions';
import {
  AUTH_SET_USER_DATA,
  AUTH_SET_USER_SIGNED_OUT,
} from './constants/ActionTypes';

const setUserDataAction = createAction(AUTH_SET_USER_DATA);
const setUserIsSignedOutAction = createAction<any>(AUTH_SET_USER_SIGNED_OUT);

export { setUserDataAction, setUserIsSignedOutAction };



// WEBPACK FOOTER //
// ./src/auth/actions.ts